import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        primary: colors.teal.lighten1,
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3,
        background: colors.indigo.lighten5,
        blubb1: colors.red.lighten3,
      },
      dark: {
        primary: colors.teal.lighten1,
        background: colors.indigo.lighten5,
        blubb1: colors.red.darken3,
      },
    },
  },
});
